import React, { Component } from "react"
import FAQItem from "../faqItem/faqItem"
import Accordion from "react-bootstrap/Accordion"

class FAQList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeKey: null,
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeCategory !== prevProps.activeCategory) {
      this.setState({
        activeKey: null,
      })
    }
  }
  render() {
    return (
      <div>
        <Accordion activeKey={this.state.activeKey}>
          {this.props.activeCategory.map((question, index) => (
            <FAQItem
              question={question}
              key={index}
              keyForEvent={index}
              activeKey={this.state.activeKey}
              handleClick={() => {
                this.state.activeKey === index
                  ? this.setState({
                      activeKey: null,
                    })
                  : this.setState({
                      activeKey: index,
                    })
              }}
            />
          ))}
        </Accordion>
      </div>
    )
  }
}
export default FAQList
